import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Command } from 'app/models/command';
import { SiteReviewService } from 'app/services/site-review.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, finalize } from 'rxjs';

@Component({
  selector: 'app-pge-pm-search',
  standalone: false,
  templateUrl: './pge-pm-search.html',
  styleUrl: './pge-pm-search.css'
})
export class PgePmSearch {

  searchByOption = '';
  searchInput: string = '';
  startDateRange: Date;
  endDateRange: Date;
  activeSearch: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PgePmSearch>,
    private siteRevService: SiteReviewService,
    private toastr: ToastrService
  ) { }

  onSearchByChange(event: any) {
    this.searchByOption = event.value;
  }

  search() {
    if (!this.searchInput?.trim()) {
      this.activeSearch = false;
      this.dialogRef.close();
      return;
    }

    this.activeSearch = true;

    const parsedInput = this.searchInput
      .split(/[\n;,]+/)
      .map(input => input.trim())
      .filter(input => input)
      .join(', ');

    const searchParams = {
      input: parsedInput,
      searchBy: this.searchByOption,
      startDate: this.startDateRange,
      endDate: this.endDateRange
    };

    //
    let cmd = new Command();
    cmd.procedure = 'cmdPGEWorkbookReporting';
    cmd.addParameter('JobNumbers', parsedInput);
    
    this.siteRevService.command(cmd).toPromise().then(async res => {
      if (res) {
        const resultObj = {
          data: res,
          searchBy: this.searchByOption,
          searchInput: this.searchInput,
          startDate: this.startDateRange,
          endDate: this.endDateRange
        };
        this.dialogRef.close(resultObj);
      } else {
        this.dialogRef.close();
      }
    });
    //
  }

  close() {
    this.activeSearch = false;
    this.dialogRef.close();
  }

}
